import {
  Stack,
  Button,
  TextField,
  Stepper,
  Step,
  StepLabel,
  Select,
  MenuItem,
  Typography,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Autocomplete,
} from "@mui/material"
import { useEffect, useMemo, useState } from "react"
import Modal from "../ui/Modal"
import { useSnackbar } from "notistack"
import { DatePicker } from "../ui/DateTimePickers"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs from "dayjs"
import FormItem from "../ui/FormItem"
import { Auth } from "aws-amplify"
import {
  createAdmission,
  editStudent,
  fetchAdmissionEvent,
  getAllDegree,
  getAllPrograms,
  searchInstitutes,
  updateAdmission,
} from "../../api"
import AddFeeComponent from "./AddFeeComponent"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import { ExpandMore } from "@mui/icons-material"

const steps = [
  "Basic Details",
  "Personal Details",
  "Admission Details",
  "Fee Schedule",
]

const documents = [
  "Exam Marksheet",
  "Transfer Certificate",
  "Caste Certificate",
  "Income Certificate",
  "Domicile Certificate",
  "Aadhar/PAN Card",
]

const academicYears = ["2023-24", "2022-23"]

const castes = ["General", "OBC", "SC", "ST"]

const AddStudent = ({ admissionData, ...props }) => {
  const [activeStep, setActiveStep] = useState(0)
  const [loading, setLoading] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    password: "",
    email: "",
    phoneNumber: "",
    type: "STUDENT",
    fatherName: "",
    motherName: "",
    alternateNumber: "",
    currentAddress: "",
    permanentAddress: "",
    dob: dayjs(),
    caste: "",
    program: admissionData?.program || "",
    department: "",
    academicYear: admissionData?.academicYear || "",
    admissionDate: admissionData?.fromDate || dayjs(),
    currency: "INR",
    schedule: "Monthly",
    scheduleStartDate: dayjs(),
    nextDueDate: dayjs(),
    lastDueDate: dayjs(),
    totalFee: 0,
    feeCollected: 0,
  })
  const [studentID, setStudentID] = useState(null)
  const [doc, setDoc] = useState(0)
  const [files, setFiles] = useState(documents.map((_) => null))
  const [feeComponentOpen, setFeeComponentOpen] = useState(false)
  const [programs, setPrograms] = useState([])

  const handleNext = async () => {
    if (activeStep === 0) {
      signUp()
    } else if (activeStep === 1) {
      addPersonalDetails()
    } else if (activeStep === 2) {
      addAdmission()
    } else if (activeStep === 3) {
      addFeeSchedule()
    }
  }

  const handlePrev = async () => {
    if (activeStep === 0) props.close()
    else if (activeStep === 1) setActiveStep(0)
    else if (activeStep === 2) setActiveStep(1)
    else if (activeStep === 3) setActiveStep(2)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const signUp = async () => {
    setLoading(true)
    try {
      const newStudent = await Auth.signUp({
        username: formData.username,
        password: formData.password,
        attributes: {
          name: formData.name,
          email: formData.email,
          phone_number: formData.phoneNumber,
          "custom:type": formData.type,
        },
      })
      setStudentID(newStudent.userSub)

      enqueueSnackbar("Student registered.", { variant: "success" })
      setLoading(false)
      setActiveStep(1)
    } catch (e) {
      console.log(e)
      enqueueSnackbar(e.message, { variant: "error" })
      setLoading(false)
    }
  }

  const addPersonalDetails = async () => {
    setLoading(true)
    const data = {
      id: studentID,
      fatherName: formData.fatherName,
      motherName: formData.motherName,
      alternateNumber: formData.alternateNumber,
      currentAddress: formData.currentAddress,
      permanentAddress: formData.permanentAddress,
      caste: formData.caste,
      dob: formData.dob,
    }

    editStudent(data)
      .then((res) => {
        enqueueSnackbar("Personal details added.", { variant: "success" })
        setLoading(false)
        setActiveStep(2)
      })
      .catch((e) => {
        console.log(e)
        enqueueSnackbar(e.data, { variant: "error" })
        setLoading(false)
      })
  }

  const [admissionID, setAdmissionID] = useState("")
  const [institute, setInstitute] = useState("")
  const [institutes, setInstitutes] = useState([])
  const [searching, setSearching] = useState(false)

  const fetchInstitutes = (value) => {
    searchInstitutes(value)
      .then((res) =>
        setInstitutes(res.data.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => console.log(err))
      .finally(() => setSearching(false))
  }
  const [degrees, setDegrees] = useState([])
  const getDepartments = () => {
    getAllDegree()
      .then((res) => setDegrees(res.data))
      .catch((err) => console.log(err))
  }
  const fetchPrograms = (degree) => {
    getAllPrograms({
      limit: 50,
      filter: {
        degree,
      },
    })
      .then((res) => setPrograms(res.data.rows))
      .catch((err) => console.log(err))
  }
  useEffect(() => {
    getDepartments()
  }, [])

  // code for adding documents

  const filesRemaining = useMemo(
    () => files.filter((f) => f === null).length,
    [files]
  )
  const updateFiles = (i, val) =>
    setFiles([...files.slice(0, i), val, ...files.slice(i + 1)])

  const addAdmission = async () => {
    setLoading(true)
    const data = {
      user: studentID,
      admissionDate: formData?.admissionDate,
      instituteId: formData?.instituteId,
      admissionProgram: formData?.program,
    }

    fetchAdmissionEvent(formData.academicYear, formData.instituteId)
      .then((res) =>
        createAdmission({
          ...data,
          admissionEventId: res.data?.id,
        })
      )
      .then((res) => {
        enqueueSnackbar("Admission done", { variant: "success" })
        setAdmissionID(res.data.admissionId)
        setActiveStep(3)
      })
      .catch((e) => enqueueSnackbar(e.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  // code for adding fee components

  const [feeComps, setFeeComps] = useState([])
  const addFeeComp = (feeComp) => setFeeComps([...feeComps, feeComp])

  const addFeeSchedule = async () => {
    setLoading(true)
    const data = {
      id: admissionID,
      feeScheduleArray: feeComps,
    }

    updateAdmission(data)
      .then(() => {
        enqueueSnackbar("Fee Schedule created. Process finished.", {
          variant: "success",
        })
        setLoading(false)
        props.close()
      })
      .catch((e) => {
        console.log(e)
        enqueueSnackbar(e.data, { variant: "error" })
        setLoading(false)
      })
  }

  return (
    <Modal
      {...props}
      title="Add Student"
      actionText={activeStep === steps.length - 1 ? "Finish" : "Next"}
      action={handleNext}
      cancelText={activeStep === 0 ? "Cancel" : "Previous"}
      cancelAction={handlePrev}
      loading={loading}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <Stack spacing={2} marginTop={2}>
          {/*------------------------- FIRST STEP -> BASIC DETAILS----------------------------------- */}
          {activeStep === 0 && (
            <>
              <TextField
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
              <TextField
                label="Username"
                name="username"
                value={formData.username}
                onChange={handleChange}
              />
              <TextField
                label="Password"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
              />
              <TextField
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              <TextField
                label="Phone"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
              />
            </>
          )}
          {/*------------------------- SECOND STEP -> PERSONAL DETAILS----------------------------------- */}
          {activeStep === 1 && (
            <>
              <TextField
                label="Father's name"
                name="fatherName"
                value={formData.fatherName}
                onChange={handleChange}
              />
              <TextField
                label="Mother's name"
                name="motherName"
                value={formData.motherName}
                onChange={handleChange}
              />
              <TextField
                label="Alternate number"
                name="alternateNumber"
                value={formData.alternateNumber}
                onChange={handleChange}
              />

              <Stack direction="row" sx={{ gap: 2 }}>
                <FormItem label="Caste">
                  <Select
                    name="caste"
                    value={formData.caste}
                    onChange={handleChange}
                  >
                    {castes.map((c) => (
                      <MenuItem value={c}>{c}</MenuItem>
                    ))}
                  </Select>
                </FormItem>

                <FormItem label="Date of birth">
                  <DatePicker
                    value={formData.dob}
                    onChange={(date) =>
                      setFormData({
                        ...formData,
                        dob: date,
                      })
                    }
                  />
                </FormItem>
              </Stack>
              <TextField
                label="Current Address"
                name="currentAddress"
                value={formData.currentAddress}
                onChange={handleChange}
              />
              <TextField
                label="Permanent Address"
                name="permanentAddress"
                value={formData.permanentAddress}
                onChange={handleChange}
              />
            </>
          )}
          {/*------------------------- THIRD STEP -> ADMISSION DETAILS----------------------------------- */}
          {activeStep === 2 && (
            <>
              <FormItem label="Institute">
                <Autocomplete
                  loading={searching}
                  value={formData.instituteId}
                  onChange={(_, val) => {
                    setFormData({
                      ...formData,
                      instituteId: val.id,
                    })
                  }}
                  inputValue={institute}
                  onInputChange={(_, val) => {
                    setInstitute(val)
                    fetchInstitutes(val)
                  }}
                  getOptionLabel={(option) => option.label}
                  options={institutes}
                  renderInput={(params) => <TextField {...params} />}
                />
              </FormItem>
              <Stack direction="row" spacing={2} alignItems="center">
                <FormItem label="Department">
                  <Select
                    name="department"
                    value={formData.department}
                    onChange={(e) => {
                      handleChange(e)
                      fetchPrograms(e.target.value)
                    }}
                  >
                    {degrees.map((degree) => (
                      <MenuItem value={degree}>{degree}</MenuItem>
                    ))}
                  </Select>
                </FormItem>
                <FormItem label="Program">
                  <Select
                    name="program"
                    value={formData.program}
                    onChange={handleChange}
                    disabled={!formData.department}
                  >
                    {programs.map((p) => (
                      <MenuItem value={p.id}>{p.name}</MenuItem>
                    ))}
                  </Select>
                </FormItem>
              </Stack>

              <Stack direction="row" spacing={2} alignItems="center">
                <FormItem label="Academic year">
                  <Select
                    name="academicYear"
                    value={formData.academicYear}
                    onChange={handleChange}
                    disabled={!formData.department}
                  >
                    {academicYears.map((p) => (
                      <MenuItem value={p}>{p}</MenuItem>
                    ))}
                  </Select>
                </FormItem>
                <FormItem label="Admission Date">
                  <DatePicker
                    name="admissionDate"
                    value={formData.admissionDate}
                    onChange={(date) =>
                      setFormData({
                        ...formData,
                        admissionDate: date,
                      })
                    }
                  />
                </FormItem>
              </Stack>

              <FormItem
                label={
                  "Add Documents (" +
                  (filesRemaining
                    ? filesRemaining + " files remaining)"
                    : "All files selected)")
                }
              >
                <Stack direction="row" spacing={2} alignItems="stretch">
                  <Select
                    value={doc}
                    onChange={(ev) => setDoc(ev.target.value)}
                    fullWidth
                  >
                    {documents.map((doc, i) => (
                      <MenuItem value={i}>{doc}</MenuItem>
                    ))}
                  </Select>
                  <Button variant="contained" component="label">
                    {files[doc] ? "Change" : "Upload"}

                    <input
                      onChange={(ev) => updateFiles(doc, ev.target.files[0])}
                      hidden
                      accept="application/pdf"
                      type="file"
                    />
                  </Button>
                </Stack>
                <Stack spacing={1} mt={2}>
                  {files?.map((f, i) =>
                    f ? (
                      <Stack
                        direction="row"
                        justifyContent={"space-between"}
                        spacing={2}
                        alignItems="center"
                      >
                        <span>
                          <b>{documents[i]}</b> : {f.name}
                        </span>

                        <Stack
                          direction="row"
                          spacing={0.5}
                          sx={{ flex: "none" }}
                        >
                          <IconButton size="small" component="label">
                            <EditIcon fontSize="small" />
                            <input
                              onChange={(ev) =>
                                updateFiles(i, ev.target.files[0])
                              }
                              hidden
                              accept="application/pdf"
                              type="file"
                            />
                          </IconButton>
                          <IconButton
                            onClick={() => updateFiles(i, null)}
                            color="error"
                            size="small"
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Stack>
                      </Stack>
                    ) : (
                      ""
                    )
                  )}
                </Stack>
              </FormItem>
            </>
          )}
          {/*------------------------- FOURTH STEP -> FEE SCHEDULE----------------------------------- */}
          {activeStep === 3 && (
            <>
              <Button
                variant="contained"
                onClick={() => setFeeComponentOpen(true)}
                fullWidth
              >
                Add Fee Component
              </Button>

              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography>
                  {feeComps.length
                    ? "Fee Components :"
                    : "No Fee Components added"}
                </Typography>
              </Stack>
              <Stack>
                {feeComps.map((feeComp) => (
                  <FeeComponentCard data={feeComp} />
                ))}
              </Stack>
            </>
          )}
        </Stack>
      </LocalizationProvider>
      <AddFeeComponent
        isOpen={feeComponentOpen}
        close={() => setFeeComponentOpen(false)}
        add={addFeeComp}
      />
    </Modal>
  )
}

const FeeComponentCard = ({ data }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />} sx={{ px: 2 }}>
        <Typography>{data?.feeHead + " (" + data.schedule + ")"}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid spacing={1} container>
          {!!data.feeComponentArray.length && (
            <Grid
              container
              item
              xs={12}
              spacing={2}
              sx={{ fontWeight: 600 }}
              mb={1}
            >
              <Grid item xs={6}>
                Particulars
              </Grid>
              <Grid item xs={3}>
                Due
              </Grid>
              <Grid item xs={3}>
                Discount
              </Grid>
            </Grid>
          )}

          {data.feeComponentArray.map((d) => (
            <Grid container item xs={12} spacing={2}>
              <Grid item xs={6}>
                {d.name}
              </Grid>
              <Grid item xs={3}>
                <TextField size="small" disabled value={"₹" + d.amount} />
              </Grid>
              <Grid item xs={3}>
                <TextField size="small" disabled value={"₹" + d.discount} />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}

export default AddStudent
